(function () {
  function revealProductList(panel) {
    if (!panel) return;
    var list = panel.querySelector('product-list');
    if (list && typeof list.reveal === 'function') {
      list.reveal();
    }
  }

  function activateTab(tabs, panels, index) {
    tabs.forEach(function (tab, tabIndex) {
      var selected = tabIndex === index;
      tab.classList.toggle('is-selected', selected);
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    panels.forEach(function (panel, panelIndex) {
      var isActive = panelIndex === index;
      panel.toggleAttribute('hidden', !isActive);
      if (isActive) {
        revealProductList(panel);
      }
    });
  }

  function moveNavigationToBanner(nav) {
    if (!nav) return false;

    var mount = document.querySelector('[data-product-tabs-nav-mount]');
    if (mount) {
      nav.classList.remove('product-tabs-navigation--hidden');
      mount.replaceChildren(nav);
      return true;
    }

    var bannerProse = document.querySelector('.shopify-section--collection-banner .prose');
    if (bannerProse) {
      nav.classList.remove('product-tabs-navigation--hidden');
      bannerProse.appendChild(nav);
      return true;
    }

    return false;
  }

  function initSection(sectionEl) {
    if (sectionEl.dataset.productTabsInitialized === 'true') return;

    var nav = sectionEl.querySelector('[data-product-tabs-navigation]');
    var panels = sectionEl.querySelectorAll('[data-product-tab-panel]');
    if (!nav || !panels.length) return;

    sectionEl.dataset.productTabsInitialized = 'true';

    if (sectionEl.querySelector('[data-navigation-in-banner]')) {
      moveNavigationToBanner(nav);
    }

    var tabs = nav.querySelectorAll('[data-product-tab-trigger]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        var index = parseInt(tab.getAttribute('data-product-tab-trigger'), 10);
        if (isNaN(index)) return;
        activateTab(tabs, panels, index);
      });
    });
  }

  function init() {
    document.querySelectorAll('.shopify-section--product-tabs').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;

    if (event.target.classList.contains('shopify-section--product-tabs')) {
      delete event.target.dataset.productTabsInitialized;
      initSection(event.target);
    }

    if (event.target.classList.contains('shopify-section--collection-banner')) {
      document.querySelectorAll('.shopify-section--product-tabs').forEach(function (sectionEl) {
        delete sectionEl.dataset.productTabsInitialized;
        initSection(sectionEl);
      });
    }
  });
})();
